import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

export default class DialogProvider extends React.Component {
  state = {
    open: false,
    dialogProps: undefined,
  }

  handleOpen = dialogProps => {
    this.setState({ open: true, dialogProps })
  }

  handleClose = () => {
    this.setState({ open: false, dialogProps: undefined })
  }

  getChildContext() {
    return { openDialog: this.handleOpen }
  }

  render() {
    const { children } = this.props

    const actions = [<FlatButton label="Cancel" onClick={this.handleClose} />]
    return (
      <React.Fragment>
        {children}
        <Dialog
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          {...this.state.dialogProps}
        />
      </React.Fragment>
    )
  }
}

DialogProvider.childContextTypes = {
  openDialog: PropTypes.func,
}

export function withDialogs(Component) {
  class WithDialogs extends React.Component {
    render() {
      return <Component {...this.props} openDialog={this.context.openDialog} />
    }
  }
  WithDialogs.contextTypes = {
    openDialog: PropTypes.func,
  }
  return WithDialogs
}



// WEBPACK FOOTER //
// ./src/components/DialogProvider.js